'use client';
import React from 'react';
import { usePathname } from 'next/navigation';
import GlobalMusicPlayerBar from './GlobalMusicPlayerBar';

export default function PublicMusicPlayerGate() {
  const pathname = usePathname();
  if (pathname?.startsWith('/admin')) return null;
  return <GlobalMusicPlayerBar />;
}
